import { createContext } from 'react';

export type AppContextProps = {
  histories: string[];
  windowWidth: number;
  windowHeight: number;
  onToastSuccess: (message: string) => void;
  onToastError: (message: string) => void;
};

export const AppContext = createContext<AppContextProps | null>(null);
